module.exports = __webpack_public_path__ + "static/media/18ECA40.fee67df8.jpg";